import { useEffect } from "react";
import mixpanel from "mixpanel-browser";


const Index = () => {

 const email = new URLSearchParams(window.location.search).get('email');


 useEffect(()=>{
    mixpanel.track("Response Clicked",{
        email: email?email:"Email Not Captured"
    });
 },[email]);


    //Import Mixpanel SDK
 
// Near entry of your product, init Mixpane

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: '#f8f9fa',
            fontFamily: 'Arial, sans-serif',
            padding: '20px'
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '40px 60px',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                textAlign: 'center',
                maxWidth: '600px',
                width: '100%'
            }}>
                <div style={{
                    fontSize: '48px',
                    marginBottom: '20px'
                }}>
                    ✅
                </div>
                <h1 style={{
                    fontSize: '28px',
                    fontWeight: 'bold',
                    color: '#333',
                    marginBottom: '16px',
                    textTransform: 'capitalize'
                }}>
                    Thank You!
                </h1>
                <p style={{
                    fontSize: '18px',
                    color: '#666',
                    lineHeight: '1.6',
                    margin: '0'
                }}>
                    Thank you for your interest! We will reach out to you soon.
                </p>
            </div>
        </div>
    )
}

export default Index;